export const OTP_RATE = 31.16;



// WEBPACK FOOTER //
// ./src/shared/constants/leasing.js